import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/collection.svg';

export const IconCollection = createIconComponent(Icon);
